<script lang="ts" setup>
import ContactUsForm from '~/components/auth/forms/ContactUsForm.vue';
import AppLink from '~/components/base/AppLink.vue';
import ContactUsPage, {
  ContactUsSubmittedPage,
} from '~/utils/contents/auth/pages/ContactUsPage';

definePageMeta({ layout: 'landing', auth: false });

useHead({
  title: ContactUsPage.seo.title,
});

const submitted = ref(false);

const showSuccess = (): void => {
  submitted.value = true;
};

const onSuccess = (): void => {
  showSuccess();
};
</script>

<template>
  <div class="flex justify-center px-4 py-10 md:px-0">
    <ContactUsForm v-if="!submitted" @success="onSuccess" />

    <div
      v-else
      class="flex min-h-[60vh] items-center justify-center px-4 py-10"
    >
      <div class="contact-us-submitted flex flex-col items-center text-center">
        <img
          src="~/assets/icons/check-circle-green.png"
          :alt="ContactUsSubmittedPage.successIcon.alt"
          class="mb-4 h-12 w-12"
        />
        <h1 class="contact-us-submitted__title text-color-primary mb-4">
          {{ ContactUsSubmittedPage.title }}
        </h1>
        <p class="contact-us-submitted__subtitle text-color-secondary mb-6">
          {{ ContactUsSubmittedPage.subtitle }}
        </p>
        <div class="flex gap-4">
          <AppLink
            to="/"
            :label="ContactUsSubmittedPage.actions.backToHome.label"
            :data-testid="ContactUsSubmittedPage.actions.backToHome.dataTestId"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.contact-us-submitted {
  max-width: 480px;

  &__title {
    font-weight: 700;
    font-size: 24px;
    line-height: 120%;

    @media (min-width: 768px) {
      font-size: 32px;
    }
  }

  &__subtitle {
    font-size: 16px;
    font-weight: 400;
    line-height: 140%;
  }
}
</style>
